<ng-template [ngIf]="chart">
  <canvas
    *ngIf="chart.datasets.length > 0"
    baseChart
    [datasets]="chart.datasets"
    [labels]="chart.labels"
    [options]="chart.options"
    [colors]="chart.colors"
    [legend]="chart.legend"
    [chartType]="chart.chartType"
  >
  </canvas>
  <div class="no-data-container" *ngIf="chart.datasets.length === 0">
    <h3>{{ noDataMessage | translate }}</h3>
  </div>
</ng-template>
